/**
 * External destinations that appear on more than one surface.
 *
 * "Talk to sales" was previously pointing at four different places depending
 * on where you clicked it — an in-app booking page in the header, and
 * three separate Calendly links elsewhere — so the same label produced a
 * different booking experience per page. One constant, one destination.
 *
 * Every booking surface on the site now resolves through TALK_TO_SALES_URL,
 * so changing the destination is a one-line change rather than a hunt.
 *
 * IT IS NOW AN INTERNAL PATH, NOT A CALENDAR. Every "Talk to sales" control
 * lands on /talk-to-sales, which asks who you are and what you need through the
 * Close web form. Booking happens in the follow-up. Sending people straight to
 * a calendar meant the lead existed only as a calendar invite — never in the
 * CRM, with no record of what they wanted or of the SMS consent the form
 * captures.
 *
 * Keep this a path. Anything that treats it as an external URL (target="_blank"
 * with rel="noopener") still works, but a real route is what makes the CTA
 * navigable in-app.
 */
export const TALK_TO_SALES_URL = '/talk-to-sales';

/** The calendar itself, kept for the follow-up email and for sales' own use. */
export const SALES_CALENDAR_URL = 'https://calendly.com/tonyennis/see-giga-in-action-clone';

/**
 * The address to reach a human without booking a slot.
 *
 * A calendar is a real barrier for anyone who has a question rather than an
 * evaluation: it asks for a name, a company, and thirty minutes of a future
 * day before they can say a sentence. Every booking CTA is now paired with
 * this so there is always a lower-commitment way through.
 */
export const SUPPORT_EMAIL = 'support@getgiga.com';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
